require('./cardSituationFilter.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText } = require('core/i18n').i18n;
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');

//@constants
const {
    CARD_SITUATION_FILTER_ALL,
    CARD_SITUATION_FILTER_AUTHORIZED,
    CARD_SITUATION_FILTER_LIQUIDATED,
    CARD_SITUATION_FILTER_PENDING_LIQUIDATION
} = require('constants/index');

class CardSituationFilter extends React.Component {
    constructor(props) {
        super(props);
        const { immFilter } = this.props;

        this.state = {
            selected: immFilter.get('selected')
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.buildRadioButtons = this.buildRadioButtons.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildRadioButtons() {
        const options = [
            CARD_SITUATION_FILTER_ALL,
            CARD_SITUATION_FILTER_LIQUIDATED,
            CARD_SITUATION_FILTER_PENDING_LIQUIDATION,
            CARD_SITUATION_FILTER_AUTHORIZED
        ];
        const labels = [
            'filterCardSituation-all',
            'filterCardSituation-liquidated',
            'filterCardSituation-pendingLiquidation',
            'filterCardSituation-authorized'
        ];

        return options.map((option, index) => {
            const label = (
                <div className="situation-filter__radio-label">
                    <FormattedText className="situation-filter__radio-label-primary" value={labels[index]} /> 
                </div>
            );

            return (
                <RadioButton
                    className="situation-filter__radio-option"
                    key={index}
                    label={label}
                    value={option}
                />
            );
        });
    }

    handleFilterChange(value) {
        const selected = value === CARD_SITUATION_FILTER_ALL ? '' : value;

        this.setState({
            selected
        });

        this.props.onChangeSelected(selected);
    }

    render() {
        const radioButtonsSection = this.buildRadioButtons();
        const selectedValue = !!this.state.selected ? this.state.selected : CARD_SITUATION_FILTER_ALL;

        return (
            <div className={this.props.last ? 'situation-filter__last' : 'situation-filter'}>
                <h3 className="situation-filter__title">
                    <FormattedText value="filterCardSituation-title" />
                </h3>
                <RadioButtonGroup
                    name="situation-filter"
                    idPrefix="situation-filter-radio"
                    selectedValue={selectedValue}
                    onChange={this.handleFilterChange}
                    className="situation-filter__options"
                >
                    {radioButtonsSection}
                </RadioButtonGroup>
            </div>
        );
    }
}

CardSituationFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onChangeSelected: PropTypes.func,
    last: PropTypes.bool
};

CardSituationFilter.defaultProps = {
    onChangeSelected: () => { },
    last: false
};

module.exports = CardSituationFilter;
